export type PublicSitePage = 'about' | 'events' | 'courses' | 'pricing' | 'privateBookings' | 'schedule' | 'terms' | 'privacy'

export function resolvePublicSitePage(pathname: string): PublicSitePage {
    if (pathname.startsWith('/kursy')) return 'courses'
    if (pathname.startsWith('/wydarzenia')) return 'events'
    if (pathname.startsWith('/indywidualne')) return 'privateBookings'
    if (pathname === '/cennik') return 'pricing'
    if (pathname === '/o-studiu') return 'about'
    if (pathname === '/regulamin') return 'terms'
    if (pathname === '/polityka-prywatnosci') return 'privacy'
    return 'schedule'
}

export type PublicSiteNavItem = {
    href: string
    key: string
    page: PublicSitePage
}

export const PUBLIC_SITE_NAV_ITEMS: PublicSiteNavItem[] = [
    {href: '/', key: 'publicEntry.nav.schedule', page: 'schedule'},
    {href: '/cennik', key: 'publicEntry.nav.pricing', page: 'pricing'},
    {href: '/o-studiu', key: 'publicEntry.nav.about', page: 'about'},
]
